// import { generateActions } from "helpers/generateActions";
export const CREATE_SHIPMENT = "CREATE_SHIPMENT";
export const CREATE_SHIPMENT_SUCCESS = "CREATE_SHIPMENT_SUCCESS";


export const API_ERROR = "API_ERROR";

